export interface PopupsState {
    product: string
}

export function createInitialPopupsState(): PopupsState {
    return {
        product: 'dashboard',
    }
}
